import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import type { SearchDataQuery, SearchDataQueryVariables } from './api.graphql';
import { SearchData } from './api.graphql';

export type SearchPageFeatureConfigs = SearchDataQuery['featureConfigs'];

export type SearchPageData = {
	viewer: SearchDataQuery['viewer'];
	featureConfigs: SearchPageFeatureConfigs;
};

export async function getSearchPageData({ gql: { fetch } }: UtilityContext): Promise<SearchPageData> {
	const { data } = await fetch<SearchDataQuery, SearchDataQueryVariables>({
		query: SearchData,
		rejectOnError: true,
	});

	return { viewer: data.viewer, featureConfigs: data.featureConfigs };
}
